// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9cb0c4c0","455":"baac64d9"}[chunkId] + ".chunk.js";
};